import React, { useCallback } from 'react';

import Accordion from 'components/Accordion';
import Button from 'components/DesignSystem/Button';

import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  resetCP,
  selectCPMFTrackingForecastSubpage,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import useChartRequestTrigger from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useChartRequestTrigger';
import useSavePreference from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useSavePreference';
import useApplyOpenDefaults from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useApplyOpenDefaults';
import FormModal from 'components/PreferenceModals/FormModal';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import { useClosure } from 'utils/hooks';
import Preferences from './Preferences';
import Groups from './Groups';
import MultiGroup from './MultiGroup';
import Location from './Location';
import MultiLocation from './MultiLocation';
import TimeFrequencies from './TimeFrequencies';
import Models from './Models';
import ForecastDate from './ForecastDate';
import Variables from './Variables';
// import InclusionCheckboxes from './InclusionCheckboxes';
import Members from './Members';
import MultiModel from './MultiModel';
import Rounds from './Rounds';

export default function DetailedView() {
  const subpage = useSelector(selectCPMFTrackingForecastSubpage);
  const triggerRequest = useChartRequestTrigger();
  // Preenche a seleção default e auto-consulta ao abrir cada modo (#1822, Área 3).
  useApplyOpenDefaults();
  const clearSelection = useCallback(() => {
    store.dispatch(resetCP());
  }, []);
  const {
    showConfirmationModal,
    setShowConfirmationModal,
    showErrorModal,
    setShowErrorModal,
    errorMessage,
    showFormModal,
    setShowFormModal,
    valid,
    isLoading,
    onNameChange,
    handleSubmit,
    disabled: saveDisabled,
  } = useSavePreference();

  return (
    <div>
      <ConfirmationModal
        open={showConfirmationModal}
        closing={useClosure(setShowConfirmationModal, false)}
      />
      <ErrorModal
        open={showErrorModal}
        closing={useClosure(setShowErrorModal, false)}
        message={errorMessage}
      />
      <FormModal
        show={showFormModal}
        onHide={useClosure(setShowFormModal, false)}
        valid={valid}
        isLoading={isLoading}
        onNameChange={onNameChange}
        handleSubmit={handleSubmit}
      />
      <Accordion>
        <Preferences />
        {(subpage === 'locations') && (
          <>
            <MultiGroup />
            <MultiLocation />
            <TimeFrequencies />
            <Models />
            <Variables />
            <ForecastDate />
            {/* <InclusionCheckboxes /> */}
          </>
        )}
        {(subpage === 'members') && (
          <>
            <Groups />
            <Location />
            <TimeFrequencies />
            <Models />
            <Members />
            <Variables />
            <ForecastDate />
          </>
        )}
        {(subpage === 'models') && (
          <>
            <Groups />
            <Location />
            <TimeFrequencies />
            <ForecastDate />
            <MultiModel />
            <Variables />
          </>
        )}
        {(subpage === 'rounds') && (
          <>
            <Groups />
            <Location />
            <TimeFrequencies />
            <Models />
            <Variables />
            <Rounds />
          </>
        )}
        <Button
          className="w-100 mt-5"
          onClick={useClosure(setShowFormModal, true)}
          disabled={saveDisabled}
        >
          Salvar nova preferência
        </Button>
        <Button
          className="w-100 mt-1"
          onClick={triggerRequest}
          disabled={triggerRequest === undefined}
        >
          Realizar consulta
        </Button>
        <Button
          type="secondary"
          className="w-100 mt-1"
          onClick={clearSelection}
        >
          Limpar gráfico
        </Button>
      </Accordion>
    </div>
  );
}
